//use strict
if (typeof Banner === 'undefined') {
    var Banner = {};
}
(function () {
    // Prevent duplicate initialization
    if (!!window['teaserPreload']) {
        return;
    }

    // Initialize PreloadTeasers
    Banner.PreloadTeasers = new (function () {
        window['_boot'].then(() => {
            if (window['clientConfig']) {
                const { vnDevice, vnUser, vnProducts, vnPage, bmaUserInterfaceConfig, bmaEnvironmentConfig } = window['clientConfig'];
                doCmsFscInit(vnDevice, bmaEnvironmentConfig);
                const pageName = getPageName(bmaUserInterfaceConfig);

                if (pageName !== 'NA') {
                    window['teaserPreloadLazy'] = { [pageName]: callTeasers(pageName, vnDevice, vnUser, vnProducts, vnPage) };
                }
            }
        });

        return {};
    })();

    /**
     * Determines the current page name based on URL and configuration
     * @returns {string} The page name or 'NA' if not found
     */
    function getPageName(bmaUserInterfaceConfig) {
        const { pathname } = window.location;
        const teaserPath = bmaUserInterfaceConfig?.teaserPath;

        if (pathname === '/' || pathname === '/en/sports') {
            return 'homepage';
        } else if (pathname && teaserPath) {
            return getName(pathname, teaserPath);
        }
        return 'NA';
    }

    /**
     * Extracts name from URL based on path array configuration
     * @param {string} url - The URL to process
     * @param {Array} pathArr - Array of path configurations
     * @returns {string} Extracted name or 'NA' if not found
     */
    function getName(url, pathArr) {
        if (!pathArr?.length) return 'NA';

        const cleanUrl = url.replace(/^\/|\/$/g, '');

        for (const path of pathArr) {
            if (path.includes('{')) {
                const [prefix, suffixPart] = path.split('{');
                const suffixes = suffixPart.split('|');

                const pageRouteArr = [prefix.replace(/^\/|\/$/g, '')];

                suffixes.forEach((item) => {
                    let finalURL = prefix + item.replace('}', '');

                    if (cleanUrl.startsWith('sport')) {
                        const [, sportName] = cleanUrl.split('/');
                        finalURL = finalURL.replace('<sportname>', sportName);
                    }

                    pageRouteArr.push(finalURL);
                });

                if (pageRouteArr.includes(cleanUrl)) {
                    return cleanUrl.split('/')[1];
                }
            }
        }

        return 'NA';
    }

    /**
     * Fetches and processes teasers for a given page
     * @param {string} pageName - The page name to fetch teasers for
     * @returns {Promise} Promise resolving to formatted teaser data
     */
    function callTeasers(pageName, vnDevice, vnUser, vnProducts, vnPage) {
        const url = 'en/coralsports/api/content/teasers';

        return apiCall(url, pageName, vnUser, vnProducts, vnPage)
            .then((response) => {
                const results = formatBannersResp({
                    data: response,
                    resolved: true,
                    message: pageName,
                });

                createPreloadLinks(results, vnDevice, pageName);
                return results;
            })
            .catch((err) => {
                console.error('BannerJs Teasers Error Data:', err);
            });
    }

    /**
     * Makes API call to fetch teaser data
     * @param {string} url - API endpoint
     * @param {string} pageName - Page name for the request
     * @returns {Promise} Promise resolving to API response
     */
    function apiCall(url, pageName, vnUser, vnProducts, vnPage) {
        const path = `mainbanners/${pageName}`;
        const headers = new Headers({
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Bwin-Browser-Url': window.location.host,
            'X-From-Product': 'sports',
        });

        if (vnUser?.isAuthenticated) {
            headers.append('X-Xsrf-Token', vnUser?.xsrfToken);
        }

        if (vnProducts?.coralsports.enabled) {
            headers.append('x-bwin-ozone-api', vnPage?.environment);
        }

        const requestParams = {
            path,
            subPaths: ['priority', 'regulatory', 'default'],
            prefetchDepth: '2',
        };

        return fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(requestParams),
        }).then((response) => response.json());
    }

    /**
     * Creates preload links for teaser images
     * @param {Object} teaser - Teaser object containing image URLs
     */
    function createPreloadLinks(teaser, vnDevice, pageName) {
        const defaultConfig = {
            SRCSET_MOBILE: ['120', '240', '360', '480', '720', '1024'],
            SRCSET_DESKTOP: ['120', '240', '360', '480', '720', '1024'],
            SIZES_DESKTOP_BACKGROUND: '25vw',
            SIZES_DESKTOP_FOREGROUND: '15vw',
            SIZES_MOBILE_BACKGROUND: '100vw',
            SIZES_MOBILE_FOREGROUND: '40vw',
        };

        const bannersConfig = window['clientConfig']?.['bmaEnvironmentConfig']?.['configuration']?.['BANNERS_CONFIG'] ?? defaultConfig;
        const isDesktop = !vnDevice.isMobile && !vnDevice.isTablet;
        const srcSet = isDesktop ? bannersConfig.SRCSET_DESKTOP : bannersConfig.SRCSET_MOBILE;
        const bgSizes = isDesktop ? bannersConfig.SIZES_DESKTOP_BACKGROUND : bannersConfig.SIZES_MOBILE_BACKGROUND;
        const fgSizes = isDesktop ? bannersConfig.SIZES_DESKTOP_FOREGROUND : bannersConfig.SIZES_MOBILE_FOREGROUND;

        createPreloadLink(teaser[0].imgUrl, bgSizes, srcSet);
        if (teaser[0].foregroundimage) {
            createPreloadLink(teaser[0].foregroundimage, fgSizes, srcSet);
        }

        if (isDesktop) {
            createPreloadLink(teaser[1].imgUrl, bgSizes, srcSet);
            if (teaser[1].foregroundimage) {
                createPreloadLink(teaser[1].foregroundimage, fgSizes, srcSet);
            }
            createStatDImg(teaser[0], teaser[1], bannersConfig, pageName);
        } else {
            createStatImg(teaser[0], bannersConfig, pageName);
        }
    }

    /**
     * Creates a preload link element for an image
     * @param {string} src - Image source URL
     * @param {string} sizes - Image sizes attribute
     * @param {Array} srcSet - Array of image widths for srcset
     */
    function createPreloadLink(src, sizes, srcSet) {
        const preloadLink = document.createElement('link');
        preloadLink.rel = 'preload';
        preloadLink.href = src;
        preloadLink.imageSizes = sizes;
        preloadLink.imageSrcset = computeSrcSet(src, srcSet);
        preloadLink.as = 'image';
        preloadLink.setAttribute('fetchpriority', 'high');
        console.log(preloadLink.outerHTML);
        document.head.appendChild(preloadLink);
    }

    /**
     * Computes srcset attribute value for responsive images
     * @param {string} src - Original image source
     * @param {Array} srcSet - Array of image widths
     * @returns {string} Formatted srcset attribute value
     */
    function computeSrcSet(src, srcSet) {
        const [protocol, , profileUrl, path, imgUrl] = src.split('/');
        return srcSet.map((size) => `${protocol}//${profileUrl}/cdn-cgi/image/width=${size},quality=85/${path}/${imgUrl} ${size}w`).join(',');
    }

    /**
     * Formats banner response data
     * @param {Object} res - API response
     * @returns {Array} Formatted banner data
     */
    function formatBannersResp(res) {
        const offerGroups = { target: [], library: [] };
        offerGroups.library = res.resolved && res.data ? res.data : [];
        const formattedOffer = formatSitecore(offerGroups);
        return mergeOffers(formattedOffer);
    }

    /**
     * Formats Sitecore data into offer groups
     * @param {Object} offers - Offer groups
     * @returns {Object} Formatted offer groups
     */
    function formatSitecore(offers) {
        const formattedOffers = {};
        formattedOffers.target = offers.target;

        offers.library.forEach((libOffer) => {
            switch (libOffer.type) {
                case 'priority':
                    formattedOffers.pinned = libOffer.teasers;
                    break;
                case 'default':
                    formattedOffers.library = libOffer.teasers;
                    break;
                case 'regulatory':
                    formattedOffers.rg = libOffer.teasers;
                    break;
                default:
                    break;
            }
        });

        return formattedOffers;
    }

    /**
     * Removes duplicate offers based on ID
     * @param {Array} multi - Array of offer groups
     * @returns {Array} Deduplicated offer groups
     */
    function dedupe(multi) {
        const seen = new Map();

        return multi.map((offersGroup) =>
            offersGroup.filter((offer) => {
                const offerId = offer.Id;

                if (!offerId) return true;
                if (seen.has(offerId)) return false;

                seen.set(offerId, true);
                return true;
            }),
        );
    }

    /**
     * Merges and orders offers from different groups
     * @param {Object} offerGroups - Offer groups
     * @returns {Array} Merged and formatted offers
     */
    function mergeOffers(offerGroups) {
        const maxOffers = 7;
        const target = offerGroups.target ?? [];
        const library = offerGroups.library ?? [];
        const pinned = offerGroups.pinned ?? [];
        const { rg } = offerGroups;

        const [ddStartList, ddTarget, ddLibrary] = dedupe([pinned, target, library]);
        const baseList = [...ddTarget, ...ddLibrary];

        const atLeastOneNonRgPresent = baseList.length && ddStartList.length;
        const showRg = atLeastOneNonRgPresent && maxOffers !== 1 && ddStartList.length;
        const positionedItemsCount = ddStartList.length + (showRg ? 1 : 0);
        const upperLimit = Math.max(0, maxOffers - positionedItemsCount);
        const trimmedBaseList = baseList.slice(0, upperLimit);

        let orderedList = [...ddStartList, ...trimmedBaseList];

        if (showRg && rg?.length) {
            orderedList.push(rg[0]);
        }

        if (maxOffers < orderedList.length) {
            orderedList = orderedList.slice(0, maxOffers);
            if (showRg && orderedList.length > 1 && rg?.length) {
                orderedList[orderedList.length - 1] = rg[0];
            }
        }

        return orderedList.map((offer, index) => formatOfferResponse(offer, index));
    }

    /**
     * Safely gets a property value from an object
     * @param {Object} obj - Source object
     * @param {string} key - Property key
     * @returns {*} Property value or empty string
     */
    function getObjectKeyValue(obj, key) {
        return obj?.[key] ?? '';
    }

    /**
     * Formats offer data for response
     * @param {Object} offer - Raw offer data
     * @param {number} index - Offer index
     * @returns {Object} Formatted offer
     */
    function formatOfferResponse(offer, index) {
        const OFFER_KEYS = {
            itemId: 'itemId',
            title: 'title',
            introductoryText: 'introductoryText',
            subTitle: 'subTitle',
            itemName: 'itemName',
            keyTermsAndConditions: 'keyTermsAndConditions',
            src: 'src',
            alt: 'alt',
            previousOddsValue: 'previousOddsValue',
            target: 'target',
        };

        const offerObj = {
            index,
            Id: getObjectKeyValue(offer, OFFER_KEYS.itemId),
            title: getObjectKeyValue(offer, OFFER_KEYS.title),
            introductorytext: getObjectKeyValue(offer, OFFER_KEYS.introductoryText),
            subtitle: getObjectKeyValue(offer, OFFER_KEYS.subTitle),
            itemName: getObjectKeyValue(offer, OFFER_KEYS.itemName),
            bannerStatus: true,
            tcText: getObjectKeyValue(offer, OFFER_KEYS.keyTermsAndConditions),
            brand: window['clientConfig']['vnAppInfo']['brand'] === 'CORAL' ? 'coral' : 'ladbrokes',
            tcLink: offer.termsAndConditionsLink?.url || offer.bannerLink?.url || '',
            tcTarget: offer.termsAndConditionsLink?.attributes?.target || '',
            imgUrl: getObjectKeyValue(offer.backgroundImage, OFFER_KEYS.src),
            altText: getObjectKeyValue(offer.backgroundImage, OFFER_KEYS.alt),
            link: offer?.bannerLink?.url || '',
            textAlignment: offer?.textAlignment,
            CTA: offer?.CTA?.url || '',
        };

        if (offer?.bannerLink?.attributes) {
            offerObj.target = getObjectKeyValue(offer.bannerLink.attributes, OFFER_KEYS.target);
        }

        if (offer?.foregroundImage) {
            offerObj.foregroundimage = getObjectKeyValue(offer.foregroundImage, OFFER_KEYS.src);
            offerObj.foregroundAltText = getObjectKeyValue(offer.foregroundImage, OFFER_KEYS.alt);
        }

        if (offer?.liveOddsBannerSelectionID) {
            offerObj.bannerStatus = false;
            offerObj.outcomeId = offer.liveOddsBannerSelectionID;
            offerObj.previousOdds = getObjectKeyValue(offer, OFFER_KEYS.previousOddsValue);
        }

        if ((offer.HTMLClass || offer.HTMLID) && offer.CustomCSS) {
            offerObj.htmlid = offer.htmlid;
            offerObj.htmlClass = offer.htmlClass;
            offerObj.customCSS = offer.customCSS;
        }

        return offerObj;
    }

    /**
     * Initializes CMS data
     */
    function doCmsFscInit(vnDevice, bmaEnvironmentConfig) {
        const bmaConfiguration = bmaEnvironmentConfig?.configuration;
        if (bmaConfiguration) {
            bmaConfiguration.CURRENT_PLATFORM = vnDevice.isMobile ? 'mobile' : 'desktop';

            const cmsInitUrl = `${bmaConfiguration.CMS_ENDPOINT}/${bmaConfiguration.BRAND}/initial-data/${bmaConfiguration.CURRENT_PLATFORM}`;
            window['cmsInitPromise'] = fetch(cmsInitUrl).then((data) => data.json());

            const cmsFscURL = `${bmaConfiguration.CMS_ENDPOINT}/${bmaConfiguration.BRAND}/fsc/0`;
            fetch(cmsFscURL)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('fsc call failed');
                    }
                    return response.json();
                })
                .then((jsonData) => {
                    window['fsc'] = jsonData;
                    window['fscreadtime'] = Date.now();
                })
                .catch((error) => {
                    console.error('Error while fetching the fsc data:', error);
                });
        }
    }

    function createStatImg(teaser, bannersConfig, pageName) {
        const { imgUrl, foregroundimage, textAlignment } = teaser;
        const firstBgImgSrcSet = getSrcSet(imgUrl, bannersConfig.SRCSET_MOBILE);
        const firstForeImgSrcSet = getSrcSet(foregroundimage, bannersConfig.SRCSET_MOBILE);
        const bgImgStyle = getBgImgStyle(pageName, textAlignment);
        const coralStyle = getCoralStyle(pageName);
        const fgImgStyle = getFgImgStyle();
        const isLads = window['clientConfig']?.['bmaEnvironmentConfig']?.['configuration']?.['BRAND'] === 'ladbrokes';
        const style = isLads ? bgImgStyle : coralStyle;
        const isFirstValidAlign = teaser.textAlignment != 'CENTER';
        const isFirstFgImg = isFirstValidAlign && isLads;

        const statImg = document.createElement('div');
        statImg.id = 'statImg';
        statImg.innerHTML = `
            <div style="${style}">
                <img fetchpriority="high"
                    src="${imgUrl}"
                    sizes="${bannersConfig.SIZES_MOBILE_BACKGROUND}"
                    srcset="${firstBgImgSrcSet}"
                    style="width:100%;height:100%; object-fit: cover; position: absolute; inset: 0;" />
                ${
                    isFirstFgImg
                        ? `
                <img fetchpriority="high"
                    src="${foregroundimage}"
                    sizes="${bannersConfig.SIZES_MOBILE_FOREGROUND}"
                    srcset="${firstForeImgSrcSet}"
                    style="${fgImgStyle}" />`
                        : ''
                }
            </div>
            `;
        document.body.appendChild(statImg);
    }

    function createStatDImg(teaser, teaser2, bannersConfig, page) {
        const ladsDeskStyle = getDeskLadsImgStyle(page);
        const coralDeskStyle = getDeskCoralImgStyle(page);
        const isLads = window['clientConfig']?.['bmaEnvironmentConfig']?.['configuration']?.['BRAND'] === 'ladbrokes';
        const styleDesk = isLads ? ladsDeskStyle : coralDeskStyle;
        const deskFirstBgImgStyle = getDeskFirstBgImgStyle(isLads, teaser.textAlignment);
        const deskSecondBgImgStyle = getDeskSecondBgImgStyle(isLads, teaser2.textAlignment);
        const deskFirstBgImgSrcSet = getSrcSet(teaser.imgUrl, bannersConfig.SRCSET_DESKTOP);
        const deskFirstForeImgSrcSet = getSrcSet(teaser.foregroundimage, bannersConfig.SRCSET_DESKTOP);
        const deskSecondBgImgSrcSet = getSrcSet(teaser2.imgUrl, bannersConfig.SRCSET_DESKTOP);
        const deskSecondForeImgSrcSet = getSrcSet(teaser2.foregroundimage, bannersConfig.SRCSET_DESKTOP);
        const deskFirstFgImgStyle = getDeskFgImgStyle();
        const deskSecondFgImgStyle = getDeskFgImgStyle();
        const pageWrapperStyle = getPageWrapperStyle();
        const isFirstValidAlign = teaser.textAlignment != 'CENTER';
        const isFirstFgImg = isFirstValidAlign && isLads;
        const isSecondValidAlign = teaser2.textAlignment != 'CENTER';
        const isSecondFgImg = isSecondValidAlign && isLads;

        const statImg = document.createElement('div');
        statImg.innerHTML = `
            <div style="${pageWrapperStyle}">
                <div id="statImg" style="${styleDesk}">
                <div style="${deskFirstBgImgStyle}">
                    <img fetchpriority="high"
                        src="${teaser.imgUrl}"
                        sizes="${bannersConfig.SIZES_DESKTOP_BACKGROUND}"
                        srcset="${deskFirstBgImgSrcSet}"
                        style="width:100%; height:100%; object-fit: cover; position: absolute; inset: 0;" />
                    ${
                        isFirstFgImg
                            ? `
                    <img fetchpriority="high"
                        src="${teaser.foregroundimage}"
                        sizes="${bannersConfig.SIZES_DESKTOP_FOREGROUND}"
                        srcset="${deskFirstForeImgSrcSet}"
                        style="${deskFirstFgImgStyle}" />
                    `
                            : ''
                    }
                </div>
                <div style="${deskSecondBgImgStyle}">
                    <img fetchpriority="high"
                        src="${teaser.imgUrl}"
                        sizes="${bannersConfig.SIZES_DESKTOP_BACKGROUND}"
                        srcset="${deskSecondBgImgSrcSet}"
                        style="width:100%; height:100%; object-fit: cover; position: absolute; inset: 0;" />
                    ${
                        isSecondFgImg
                            ? `
                    <img fetchpriority="high"
                        src="${teaser.foregroundimage}"
                        sizes="${bannersConfig.SIZES_DESKTOP_FOREGROUND}"
                        srcset="${deskSecondForeImgSrcSet}"
                        style="${deskSecondFgImgStyle}" />
                    `
                            : ''
                    }
                </div>
                </div>
            </div>
            `;
        document.body.appendChild(statImg);
    }

    // Mobile Style starts
    function getBgImgStyle(page, firstImgTextAlignment) {
        const pageName = page;
        const topPosition = pageName === 'homepage' ? 125 : pageName === 'cheltenham1' ? 121 : 97;
        let bgImgStyle = `position: absolute; top: ${topPosition}px; height: 40vw; width: 100%;`;
        switch (firstImgTextAlignment) {
            case 'LEFT':
                bgImgStyle += ' display: flex; justify-content: flex-end;';
                break;
            case 'RIGHT':
                bgImgStyle += ' display: flex; justify-content: flex-start;';
                break;
            default:
                break;
        }
        return bgImgStyle;
    }

    function getFgImgStyle() {
        return 'width: 40%;';
    }

    function getSrcSet(imageURL, sizeSet) {
        try {
            const parts = imageURL.split('/');
            const protocol = parts[0];
            const profileUrl = parts[2];
            const path = parts[3];
            const imgUrl = parts[4];

            return sizeSet.map((size) => `${protocol}//${profileUrl}/cdn-cgi/image/width=${size},quality=85/${path}/${imgUrl} ${size}w`).join(',');
        } catch (error) {
            return '';
        }
    }

    function getCoralStyle(page) {
        const pageName = page;
        const topPosition = pageName === 'homepage' ? 125 : pageName === 'cheltenham1' ? 166 : 104;
        const coralStyle = `position: absolute; top: ${topPosition}px; border-radius: 10px; height: 40vw; left: 12px; z-index: 5;`;
        return coralStyle;
    }
    // Mobile Style ends

    //Desktop Style starts
    function getPageWrapperStyle() {
        return 'min-width: 970px; max-width: 1600px; margin: 0 auto; position: relative;';
    }

    function getDeskLadsImgStyle(page) {
        const topPosition = page === 'homepage' ? 105 : page === 'cheltenham1' ? 264 : 185;
        return `top: ${topPosition}px; z-index: 5; display: flex; flex-direction: row; justify-content: space-between; align-items: center; height: 240px; position: absolute; left: 170px; right: 330px; gap: 10px;`;
    }

    function getDeskCoralImgStyle(page) {
        const topPosition = page === 'homepage' ? 111 : page === 'cheltenham1' ? 264 : 185;
        return `position: absolute; z-index: 5; top: ${topPosition}px; display: flex; flex-direction: row; justify-content: space-between; align-items: center; height: 240px; left: 170px; right: 330px; gap: 10px;`;
    }

    function getDeskFirstBgImgStyle(isLads, firstImgTextAlignment) {
        const borderRadius = isLads ? 0 : 10;
        let style = `position: relative; flex: 1; height: 100%; border-radius: ${borderRadius}px;`;

        if (isLads) {
            switch (firstImgTextAlignment) {
                case 'LEFT':
                    style += ' display: flex; justify-content: flex-end;';
                    break;
                case 'RIGHT':
                    style += ' display: flex; justify-content: flex-start;';
                    break;
                default:
                    break;
            }
        }

        return style;
    }

    function getDeskSecondBgImgStyle(isLads, secondImgTextAlignment) {
        const borderRadius = isLads ? 0 : 10;
        let style = `flex: 1; position: relative; height: 100%; border-radius: ${borderRadius}px;`;

        if (isLads) {
            switch (secondImgTextAlignment) {
                case 'LEFT':
                    style += ' display: flex; justify-content: flex-end;';
                    break;
                case 'RIGHT':
                    style += ' display: flex; justify-content: flex-start;';
                    break;
                default:
                    break;
            }
        }

        return style;
    }

    function getDeskFgImgStyle() {
        return 'z-index: 10; max-height: 100%;';
    }
    //Desktop Style ends
})();
